'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { XIcon } from '@phosphor-icons/react';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[+()\-\s\d]{7,20}$/;
function classify(raw) {
    const v = raw.trim();
    if (!v)
        return null;
    if (v.includes('@'))
        return EMAIL_RE.test(v) ? { email: v } : null;
    // Phone: allow +, digits, spaces, dashes, parens. Require at least 7 digits.
    const digitsOnly = v.replace(/\D/g, '');
    if (digitsOnly.length >= 7 && PHONE_RE.test(v))
        return { phone: v };
    return null;
}
export function ContactBanner({ onSubmit, onDismiss }) {
    const [value, setValue] = useState('');
    const [error, setError] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        const parsed = classify(value);
        if (!parsed) {
            setError(true);
            return;
        }
        onSubmit(parsed);
    };
    return (_jsx("div", { className: "shrink-0 border-b border-gray-200 bg-[#f5f3ff] px-3 py-2", children: _jsxs("form", { onSubmit: handleSubmit, className: "flex items-center gap-2", children: [_jsx("input", { type: "text", inputMode: "email", value: value, onChange: (e) => {
                        setValue(e.target.value);
                        if (error)
                            setError(false);
                    }, placeholder: "Leave your email or phone", "aria-label": "Email or phone (optional)", className: `h-8 flex-1 rounded-md border bg-white px-2 text-[13px] text-gray-900 placeholder:text-gray-400 focus:outline-none ${error ? 'border-red-400 focus:border-red-500' : 'border-gray-200 focus:border-[#7C3AED]'}` }), _jsx("button", { type: "submit", className: "h-8 rounded-md bg-[#7C3AED] px-3 text-[12px] font-medium text-white transition-colors hover:bg-[#6D28D9]", children: "Save" }), _jsx("button", { type: "button", onClick: onDismiss, "aria-label": "Dismiss", className: "rounded p-1 text-gray-400 transition-colors hover:bg-white hover:text-gray-600", children: _jsx(XIcon, { size: 14, weight: "bold" }) })] }) }));
}
